export const HRIS_IMPORT_LOG_STATUSES = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  MERGE_FAIL: 'MERGE_FAIL',
} as const;

export type HrisImportLogStatus = keyof typeof HRIS_IMPORT_LOG_STATUSES;

export interface HrisImportLog {
  hrisImportLogId: number;
  mergeIntegrationId: number;
  importStatus: HrisImportLogStatus | null;
  createdAt: Date;
  finishedAt: Date | null;
  duration: number | null;
  countOfEmployeeChangeLogs?: Record<string, number>;
}
